<template>
  <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap"
                view-class="p20-scrollbar__view">
    <div v-if="loading">
      <el-form style="margin-left: 30px;margin-top: 30px">
        <el-form-item>
          <el-select v-model="status" clearable placeholder="处理状态" @change="queryReport()">
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="已处理" :value="1"></el-option>
          </el-select>
          <el-input v-model="searchForm" placeholder="请输入活动名称" style="width:400px"
                    @keyup.enter.native="queryReport"
                    clearable></el-input>
          <el-button type="primary" @click="queryReport()">搜索</el-button>
          <el-button type="info" style="float: right;margin-right: 50px" @click="guidePage=true">指引</el-button>
        </el-form-item>
      </el-form>

      <el-table
          border
          :header-cell-style="{background:'#dee2ec', color: '#666666'}"
          :cell-style="{'text-align':'center','border-right':'1px solid #eee','border-bottom':'1px solid #eee'}"
          :data="reportList"
          stripe
          max-height="700"
          style="width: 100%;margin-bottom:20px">
        <el-table-column prop="activityName" label="被举报活动"></el-table-column>
        <el-table-column prop="userName" label="举报人"></el-table-column>
        <el-table-column prop="wechatPhone" label="举报人手机号"></el-table-column>
        <el-table-column prop="reason" label="举报原因"></el-table-column>
        <el-table-column prop="createTime" label="举报时间"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">{{scope.row.status === 1 ? '已处理' : '待处理'}}</template>
        </el-table-column>
        <el-table-column prop="handleTime" label="处理时间"></el-table-column>
        <el-table-column prop="operation" label="操作">
          <template slot-scope="scope" v-if="scope.row.status===0">
            <el-button type="primary" size="medium" @click="handleReport(scope.row)">标记已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="text-align: center"
                     background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pagesizes"
                     :page-size="pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="all">
      </el-pagination>

      <el-dialog title="指引" :visible.sync="guidePage" width="1000px">
        <div>
          <h2>举报管理（发起人权限一期增量）</h2>
          本页展示小程序用户在活动详情页提交的活动举报。
          <br>
          <h3>搜索：可按处理状态、活动名称筛选。<br>
            处理：核实举报后可点「标记已处理」，留痕处理人与处理时间。<br>
            若举报属实需要下架活动，请到「活动信息」页面对该活动做状态处理。<br></h3>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="guidePage = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </el-scrollbar>
</template>
<script>
import {activityReportList, activityReportHandle} from "@/common/js/index.js"

export default {
  name: "activityReport",
  // 权限说明：发起人权限一期增量，仅超管可见（后端 notSuper 强制校验）
  data() {
    return {
      guidePage: false,
      reportList: [],
      status: '',
      searchForm: '',
      all: 0,
      currentPage: 1,
      loading: false,
      pagesize: 20,
      pagesizes: [10, 20, 30, 50, 100, 200, 300, 400, 500, 1000],
    }
  },
  methods: {
    queryReport() {
      let subData = 'currPage=' + this.currentPage
          + '&pageSizePara=' + this.pagesize
          + '&activityName=' + this.searchForm
      if (this.status !== '' && this.status !== null) {
        subData += '&status=' + this.status
      }
      activityReportList(subData).then(res => {
        if (res) {
          this.reportList = res.data
          if (res.data.length !== 0) {
            this.all = res.data[0].totalCount
          } else {
            this.all = 0
          }
          this.loading = true
        }
      })
    },
    handleReport(row) {
      this.$confirm('确认该举报已核实处理？', '提示', {type: 'warning'}).then(() => {
        activityReportHandle('id=' + row.id).then(res => {
          if (res) {
            this.queryReport()
            this.$message({showClose: true, message: '已标记处理', type: 'success'})
          }
        })
      }).catch(() => {})
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSizeChange(val) {
      this.pagesize = val
    },
  },
  created() {
    this.queryReport();
  },
  watch: {
    currentPage: function () {
      this.queryReport()
    },
    pagesize: function () {
      this.queryReport()
    },
  }
}
</script>

<style scoped>
</style>
